<template>
  <div :class="horizontal?'d-flex justify-space-around':''">
    <div class="text-h6" v-html="zueri9FahrdienstStats.htmlFahrstundenAtCalculatedDate"></div>
    <div class="text-h6" v-html="zueri9FahrdienstStats.htmlDeltaMonthToDate"></div>
  </div>
</template>
<script>
export default {
  name: 'FahrdienstStatsShort',
  props: {
    horizontal:{type:Boolean,default:false},
    currentDateFormatted: String,
    zueri9FahrdienstStats: Object,
  },
};
</script>
